import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

import { Arrow } from '../../../Common/Icon';
import CategoryCarousel from './CategoryCarousel';
import CategoryStatistics from './CategoryStatistics';
import CategoryDetails from './CategoryDetails';
import CategoryList from './CategoryList';
import ModalCategoryDetails from './CategoryStatistics/ModalCategoryDetails';
import { useCategoryContext } from './CategoryProvider';

import styles from './index.module.scss';

function HowMuchToTip() {
  const navigate = useNavigate();
  const { category, subCategory, setSubCategory } = useCategoryContext();

  const isTablet = useMediaQuery({
    query: '(max-width: 768px)',
  });

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.innerWrapper}>
          <div className={styles.header}>
            <h2 className={styles.title}>
              <span>
                <span className="colorGreen">Unsure</span> about when
              </span>
              <span>or how much to tip?</span>
            </h2>
            <div className={styles.descriptionWrapper}>
              <p className={styles.description}>
                See how your <span className={styles.bold}>peers tip</span> and
                how <span className={styles.bold}>real tipped workers</span>{' '}
                expect to be tipped in a variety of industries
              </p>
              <div>
                <Button
                  icon={<Arrow />}
                  iconPosition="end"
                  size="large"
                  type="primary"
                  className={styles.button}
                  onClick={() => navigate('/categories')}
                >
                  Learn more
                </Button>
              </div>
            </div>
          </div>

          <div className={styles.content}>
            <div className={styles.categorySlider}>
              <CategoryCarousel />
            </div>
            <CategoryList className={styles.categoryList} />

            <div className={styles.detailsWrapper}>
              <CategoryDetails
                category={category}
                subCategoryIdActive={subCategory?.id || null}
                setSubCategory={setSubCategory}
              />
              <CategoryStatistics />
            </div>

            {isTablet && <ModalCategoryDetails />}
          </div>
        </div>
      </div>
    </div>
  );
}

export default HowMuchToTip;
